import { DeepCopy } from '../../tables/shared/TableEventHelpers';

export const applyFilter = (filterKey, newFilterValue, dispatch, pipelines, currentPipelineId) => {
    
    if (pipelines[currentPipelineId].requestObject !== null) {
        let newRequestObject = DeepCopy(pipelines[currentPipelineId].requestObject);
        updateRequestObject(newFilterValue, filterKey, newRequestObject);
        pipelines[currentPipelineId].requestObject = newRequestObject;
        dispatch({
            type: 'UPDATE_FETCH_PIPES',
            pipelines: pipelines,
        });
    }
};

export const applyFilterTable = (filterKey, newFilterValue, dispatch, requestObject) => {

    if (requestObject !== null) {
        let newRequestObject = DeepCopy(requestObject);
        updateRequestObject(newFilterValue, filterKey, newRequestObject);
        dispatch({ type: 'UPDATE_REQUEST_OBJECT', requestObject: newRequestObject });
    }
};


const updateRequestObject = (newFilterValue, filterKey, newRequestObject) => {
    if(filterKey === 'Status' || filterKey === 'Personal'){
        if(newFilterValue)
            newRequestObject.filters[filterKey] = newFilterValue;
        else
            delete newRequestObject.filters[filterKey];
    }
    else if (newRequestObject.filters['Users'] === undefined || newRequestObject.filters[filterKey] !== newFilterValue) {
        if (newFilterValue.length > 0) {
            newRequestObject.filters['GroupType'] = filterKey;
            newRequestObject.filters['Users'] = newFilterValue;

        }
        else delete newRequestObject.filters[filterKey];
        newRequestObject.startIndex = 0;
    }
}
